import Link from "next/link";

type RelatedLink = { href: string; title: string; description: string };

export default function RelatedLinks({
  title = "Related services",
  links,
}: {
  title?: string;
  links: RelatedLink[];
}) {
  return (
    <section
      aria-labelledby="related-links-heading"
      className="bg-gray-50 py-16 sm:py-20"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <h2
          id="related-links-heading"
          className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl"
        >
          {title}
        </h2>
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {links.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="block rounded-lg border border-gray-200 bg-white p-6 transition hover:border-blue-600 hover:shadow-sm"
            >
              <h3 className="text-lg font-semibold text-gray-900">
                {link.title}
              </h3>
              <p className="mt-2 text-sm leading-6 text-gray-600">
                {link.description}
              </p>
              <span className="mt-3 inline-block text-sm font-semibold text-blue-600">
                Learn more <span aria-hidden="true">→</span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
